module.exports = __webpack_public_path__ + "img/footer-bg.a5fedc4a.jpg";